import LittleHealthPackage from "../../assets/Health web.jpg";
import StudentHealthPackage from "../../assets/Student.jpg";
import UnderHealthPackage from "../../assets/under40.jpg";
import AboveHealthPackage from "../../assets/above40.jpg";
import DeskHealthPackage from "../../assets/desk.jpg";
import FactoryHealthPackage from "../../assets/factory.jpg";
import GoldenHealthPackage from "../../assets/above60.jpg";
import AarogyaHealthPackage from "../../assets/Aarogya.jpg";
export const healthPackages = [
    {
        title: "Little Champs Package",
        subtitle:"Ashwini's Little Champs Health Checkup",
        moto:"Nurturing Young Lives with Care and Precision",
        category:"For Kids – Age 3 to 12",
        image: LittleHealthPackage,
        newPrice: "299",
        oldPrice:"1500",
        services: ["HB", "Eye Test","Blood Grouping","Physical Examination"]
    },
    {
        title: "Smart Student Package",
        subtitle:"Ashwini's Smart Student Health Checkup",
        moto:"A Step toward a Healthier Academic Journey",
        category:"For School & College Students – Age 13 to 22",
        image: StudentHealthPackage,
        newPrice: "1299",
        oldPrice:"2699",
        services: ["CBC","RFT","LIPID PROFILE","Calcium","LIVER FUNCTION TEST","URINE R/M"]
    },
    {
        title: "Senorita Under 40 Package",
        subtitle:"Ashwini's VitalHer Wellness Checkup",
        moto:"Smart Preventive Care for today’s Young Women",
        category:"For Women Under 40",
        image: UnderHealthPackage,
        newPrice: "3699",
        oldPrice:"6666",
        services: ["CBC","ECG","Urea Creatinine","ECHO","FBS", "PPBS","TMT","CHEST X-RAY","LIPID PROFILE","URINE R/M"]
    },
    {
        title: "Senorita Above 40 Package",
        subtitle:"Ashwini's PrimeHer Wellness Checkup",
        moto:"Comprehensive Health insights for Empowered Living",
        category:"For Women 40 & Above",
        image: AboveHealthPackage,
        newPrice: "4399",
        oldPrice:"7549",
        services: ["CBC","ECG","Urea Creatinine","ECHO","FBS", "PPBS","TMT","CHEST X-RAY","LIPID PROFILE","URINE R/M","Mammography","Pap Smear From Cervix"]
    },
    {
        title: "Desk Warrior Package",
        subtitle:"Ashwini's Desk Shield Health Checkup",
        moto:"Protecting those who power the Digital World",
        category:"For Desk Workers & Professionals",
        image: DeskHealthPackage,
        newPrice: "1599",
        oldPrice:"2989",
        services: ["CBC", "RFT", "LIPID PROFILE","FBS", "PPBS","C-reactive Protein", "ESR","CHEST X-RAY","Eye Test","ECG"]
    },
    {
        title: "Industrial Health Package",
        subtitle:"Ashwini's Factory Guard Health Checkup",
        moto:"Strengthening the Backbone of our Industries",
        category:"For Industrial Workers",
        image: FactoryHealthPackage,
        newPrice: "2099",
        oldPrice:"4050",
        services: ["CBC", "RFT","LIVER FUNCTION TEST","FBS", "PPBS","C-reactive Protein","ESR","CHEST X-RAY","PFT","Audiometry"]
    },
    {
        title: "Golden Years Package",
        subtitle:"Ashwini's Golden Years Health Checkup",
        moto:"Graceful aging with guided Care",
        category:"For Senior Citizens 60+",
        image: GoldenHealthPackage,
        newPrice: "6499",
        oldPrice:"12111",
        services: ["CBC", "FBS", "PPBS","ESR","Na+","K+","Urea Creatinine","PTT","URINE R/M","LIVER FUNCTION TEST","ECG","LIPID PROFILE","ECHO","ULTRA SONOGRAPHY","PHYSICIAN CONSULTATION","CHEST X-RAY","HBA1C","PFT","TMT"]
    },
    {
        title: "Aarogya Plus Package",
        subtitle:"Ashwini's Aarogya Plus Health Checkup",
        moto:"Your Partner in Preventive Healthcare)",		
        category:"Personalized Health Checkups for Every Stage of Life",
        image: AarogyaHealthPackage,
        newPrice: "5999",
        oldPrice:"9555",
        services: ["HB","DC","TLC","FBS","PPBS","PFT","ESR","Na+","K+","Urea Creatinine","PTT","URINE R/M","STOOL R/M","VDRL","LIVER FUNCTION TEST","ECG","LIPID PROFILE","ULTRA SONOGRAPHY","CHEST X-RAY","ECHO","HBSAG","HIV","URIC ACID","PHYSICIAN CONSULTATION"]
    },
];